import React, { Fragment } from "react";
import PageTitle from "../../components/pagetitle/PageTitle";
import Header from "../../components/header/Header";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import AboutContent from "../../components/about/aboutcontent";
import AboutSolution from "../../components/SolutionSection/AboutSolution";

const AboutPage = (props) => {
  return (
    <Fragment>
      <div className="index_ico page_wrapper">
        <Header />
        <main className="page_content">
          <PageTitle pageTitle={"About Us"} pagesub={"About"} />
          <AboutContent abClass={"pt-5 pb-5"} />
          <AboutSolution abClass={"pb-5"} />
        </main>
        <Footer />
        <Scrollbar />
      </div>
    </Fragment>
  );
};
export default AboutPage;
